
export const SHIPPING_ZONES = [
    {
        id: "gratis",
        name: "Envío gratis (retiro / prueba)",
        cost: 0,
        minPurchaseForFree: 0,
        days: ["Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"],
    },
    {
        id: "macrocentro",
        name: "Macrocentro Rosario (dentro de Avellaneda, 27 de Febrero y el río)",
        cost: 2500,
        minPurchaseForFree: 25000,
        days: ["Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"],
    },
    {
        id: "rosario",
        name: "Rosario (Zona Sur, Zona Oeste y Zona Norte)",
        cost: 3500,
        minPurchaseForFree: 30000,
        days: ["Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"],
    },
    {
        id: "fisherton",
        name: "Fisherton",
        cost: 4500,
        minPurchaseForFree: 35000,
        days: ["Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"],
    },
    {
        id: "funes_baigorria",
        name: "Funes o Baigorria",
        cost: 5500,
        minPurchaseForFree: 40000,
        days: ["Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"],
    },
    {
        id: "roldan",
        name: "Roldán",
        cost: 6500,
        minPurchaseForFree: 45000,
        days: ["Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"],
    }
];

export const TIME_RANGES = [
    "09:00 a 12:00",
    "12:00 a 15:00"
];
